import router from './router'
import useReviewTripsStore from './store'
import TripsMessages from './localization'

export default {
  router,
  useTripsStore: useReviewTripsStore,
  localization: TripsMessages,
}
